<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZaLVKe/tc-custom/9780545908986.jpg?1709177418912" alt="This image is the cover for the book Dreams That Sparkle, Enchanted Pony Academy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dreams That Sparkle, Enchanted Pony Academy
      </h1>
      <p class="bookDescription body article font2">
        <b>In this fantasy tale, the most beautiful student at the Enchanted Pony Academy hopes to prove she’s more than just her looks.</b><br/><br/>Belissima is the prettiest pony at the Enchanted Pony Academy—everyone says so. The problem is, no one seems to see what else Belissima is: talented and hardworking. She dreams that someday everyone will see that her real magic doesn’t have anything to do with her looks!<br/><br/>The royal children are coming to the Academy for the selection ceremony, and Belissima is determined to show that she’s not just a pretty pony. It’s her last chance to prove everything she can be—which is so much more than a show pony.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Ann Scott
      </h2>
      
      <p class="authorDescription body article"><P><B>LISA ANN SCOTT </B>is the author of the <I>L’école des poneys enchantés</I> and the <I>La fée des souhaits</I> series, and <I>School of Charm</I>. She has been a TV news producer, reporter, and anchor, and she currently works as a voice-over artist. She lives in upstate New York.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bea4e584